import React, { useState } from 'react';

import { PrimaryButton } from 'js/src/components/common/ui/Button';
import Modal, { MODAL_SIZES } from 'js/src/components/common/ui/modal';
import Navigation from 'js/src/libs/navigation';
import type { ToggleRequestErrorPayload } from 'js/src/libs/RequestErrorEventEmitter';
import RequestErrorEventEmitter, {
    REQUEST_ERROR_EVENTS,
} from 'js/src/libs/RequestErrorEventEmitter';

export function ShowRequestErrorModal(errorMessage?: string) {
    const payload: ToggleRequestErrorPayload = {
        showModal: true,
        errorMessage: errorMessage,
    };
    RequestErrorEventEmitter.emit(REQUEST_ERROR_EVENTS.TOGGLE_REQUEST_ERROR_MODAL, payload);
}

export function HideRequestErrorModal() {
    const payload: ToggleRequestErrorPayload = {
        showModal: false,
    };
    RequestErrorEventEmitter.emit(REQUEST_ERROR_EVENTS.TOGGLE_REQUEST_ERROR_MODAL, payload);
}

export const RequestErrorModal = React.memo(function RequestErrorModal() {
    const [showing, setShowing] = useState(false);
    const [message, setMessage] = useState<string | undefined>(undefined);

    const toggleVisibility = React.useCallback(
        ({ showModal, errorMessage }: ToggleRequestErrorPayload) => {
            setShowing(showModal);
            setMessage(errorMessage);
        },
        [],
    );

    React.useEffect(() => {
        RequestErrorEventEmitter.on(
            REQUEST_ERROR_EVENTS.TOGGLE_REQUEST_ERROR_MODAL,
            toggleVisibility,
        );
        return () => {
            RequestErrorEventEmitter.off(
                REQUEST_ERROR_EVENTS.TOGGLE_REQUEST_ERROR_MODAL,
                toggleVisibility,
            );
        };
    }, [toggleVisibility]);

    return (
        <Modal
            backdrop
            footer={
                <>
                    <PrimaryButton text="Reload" onClick={Navigation.reloadPage} />
                </>
            }
            size={MODAL_SIZES.DEFAULT}
            title="Connection Error"
            showing={showing}
            closeable={false}
        >
            <div>
                {message ||
                    'Cannot connect to Lumen5. Please check your internet connection and reload the page.'}
            </div>
        </Modal>
    );
});
